import React from 'react';

import { BuiltInComponents } from 'craft/constants';
import { DocumentGrid } from 'craft/containers/Craft/DocumentGrid';
import { VIEWPORT_CONTAINER_ID, VIEWPORT_CONTENT_ID } from 'craft/containers/Viewport/constants';
import { useCraftViewportEventHandlers } from 'craft/containers/Viewport/modes/hooks/useCraftViewportEventHandlers';
import { useViewportDimensions } from 'craft/containers/Viewport/modes/hooks/useViewportDimensions';
import { useViewportBreakpoint } from 'craft/state';

import { CheckeredBackground, Content, ViewportContainer } from './components';

export interface NoSnapshotViewportProps {
  children: React.ReactNode;
  contentId: string;
  rootNodeName: string;
  isRootSelected: boolean;
}

/**
 * Renders the editor without Snapshots
 */
export const NoSnapshotViewport = React.memo(
  ({ children, rootNodeName, isRootSelected }: NoSnapshotViewportProps) => {
    const isModal = rootNodeName === BuiltInComponents.Modal;
    const viewportBreakpoint = useViewportBreakpoint();

    const { containerRef, contentRef } = useCraftViewportEventHandlers();

    const { widthOverride, heightOverride } = useViewportDimensions({ rootNodeName });

    return (
      <ViewportContainer
        id={VIEWPORT_CONTAINER_ID}
        viewport={viewportBreakpoint}
        ref={(dom: any) => {
          containerRef.current = dom;
        }}
        data-cy="editor-viewport"
        height={heightOverride}
      >
        {isModal && <CheckeredBackground width={widthOverride} height={heightOverride} />}
        <Content
          id={VIEWPORT_CONTENT_ID}
          width={widthOverride}
          ref={(dom: any) => {
            contentRef.current = dom;
          }}
        >
          <DocumentGrid isSelected={!!isRootSelected} shouldHideLine={isModal} />
          {children}
        </Content>
      </ViewportContainer>
    );
  },
);
